
// CondPagamentoSelect.js

import React from 'react';

const CondPagamentoSelect = ({ conditionMethods, selectedMethod, onChange }) => {
  return (
    <div style={{ width: '230x', marginLeft: '20px', marginTop: '0px', marginBottom: '0px' }}>
      <label htmlFor="payment-method" style={{ display: 'block', marginBottom: '0px' }}>
        Condição de Pagamento:
      </label>
      <select 
        id="payment-method" 
        value={selectedMethod} 
        onChange={(e) => onChange(e.target.value)} 
        style={{ width: '230px', height: '30px' }}
      >
        <option value="" disabled>Selecione a Condição de pagamento</option>
        {conditionMethods.map((method, index) => (
          <option key={index} value={method}>
            {method}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CondPagamentoSelect;